import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import VuiButton from "components/VuiButton";
import VuiTypography from "components/VuiTypography";

function ConfirmDialog({
  open,
  title = "Confirmar",
  message,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        <VuiTypography variant="h6" color="white">
          {title}
        </VuiTypography>
      </DialogTitle>
      <DialogContent>
        <VuiTypography variant="body2" color="text">
          {message}
        </VuiTypography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <VuiButton color="secondary" variant="outlined" onClick={onCancel}>
          {cancelLabel}
        </VuiButton>
        <VuiButton color="error" variant="gradient" onClick={onConfirm}>
          {confirmLabel}
        </VuiButton>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ConfirmDialog;
